import { render, staticRenderFns } from "./RuleUpdate.vue?vue&type=template&id=423a7b38&scoped=true&"
import script from "./RuleUpdate.vue?vue&type=script&lang=js&"
export * from "./RuleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RuleUpdate.vue?vue&type=style&index=0&id=423a7b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a7b38",
  null
  
)

export default component.exports